import { HEADER_HEIGHT } from './constants';

export const classes = {
  header:
    'place-between sticky top-0 z-30 w-full px-8 bg-sage-10 text-white shrink-0',
  logoLink: 'block',
  logo: 'h-[26px] w-auto',
  actions: 'place-end gap-3',
};

export const styles = {
  header: {
    height: HEADER_HEIGHT,
  },
};
